<template>
  <footer class="footer">
    <div class="content">
      <p class="has-text-centered">Fit4App</p>
    </div>
  </footer>
</template>

<script></script>

<style></style>
